module.exports = __webpack_public_path__ + "media/our_mission/OurValues_de-2a506157.webp";